import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object().shape({
    title: Yup.string().trim().required('This field is required'),
    content: Yup.string().trim().required('This field is required'),
  });
